import { http } from '@/system/http';
import Apps from '@/core/Apps';
import { orderBy, cloneDeep } from 'lodash';

export default {
    state: {
        surveys: [],
        surveysBackup: [],
        followUpSurveys: [],
        loaded: false,
        loading: false,
        sortBy: 'created_at',
        sortDirection: 'desc',
        // settings page refactor
        survey_settings: null,
        user_can_send_messages: false,
        has_inactive_clients: false,
    },

    mutations: {
        setSurveys(state, surveys = null) {
            state.surveys = surveys || [];
            state.surveysBackup = cloneDeep(surveys) || [];
        },

        addSurvey(state, survey) {
            state.surveys.push({ ...survey });
            state.surveysBackup.push({ ...cloneDeep(survey) });
        },

        deleteSurvey(state, survey) {
            let id = typeof survey === 'object' ? survey.id : parseInt(survey);

            state.surveys = state.surveys.filter(s => s.id !== id);
            state.surveysBackup = state.surveysBackup.filter(s => s.id !== id);
        },

        updateSurvey(state, survey) {
            let id = typeof survey === 'object' ? survey.id : parseInt(survey);
            let index = state.surveys.findIndex(s => s.id === id);

            if (index >= 0) {
                state.surveys[index] = { ...survey };
                state.surveysBackup[index] = { ...cloneDeep(survey) };
            } else {
                state.surveys.push({ ...survey });
                state.surveysBackup.push({ ...cloneDeep(survey) });
            }
        },

        setFollowUpSurveys(state, rules) {
            state.followUpSurveys = rules;
        },

        addFollowUpSurvey(state, followUpSurvey) {
            state.followUpSurveys.push({ ...followUpSurvey });
        },

        deleteFollowUpSurvey(state, followUpSurvey) {
            let id = typeof followUpSurvey === 'object' ? followUpSurvey.id : parseInt(followUpSurvey);

            state.followUpSurveys = state.followUpSurveys.filter(fs => fs.id !== id);
        },

        updateFollowUpSurvey(state, followUpSurvey) {
            let id = typeof followUpSurvey === 'object' ? followUpSurvey.id : parseInt(followUpSurvey);
            let index = state.followUpSurveys.findIndex(fs => fs.id === id);

            if (index >= 0) {
                state.followUpSurveys[index] = { ...followUpSurvey };
            } else {
                state.followUpSurveys.push({ ...followUpSurvey });
            }
        },
        sortSurveys(state, sort) {
            state.sortBy = sort.name;
            state.sortDirection = sort.direction;
        },

        setDefaultSurveySettings(state, settings) {
            state.survey_settings = settings.survey_settings;
            state.user_can_send_messages = settings.user_can_send_messages;
            state.has_inactive_clients = settings.has_inactive_clients;
        }
    },

    getters: {
        loading: (state, getters) => {
            return state.loading;
        },
        all: (state, getters) => {
            return state.surveys;
        },
        find: (state, getters) => (survey) => {
            const surveyId = typeof survey === 'object' && survey !== null ? survey.id : parseInt(survey) || 0;

            return getters.all.find(p => p.id === surveyId);
        },

        isLoaded(state, getters) {
            return state.loaded;
        },

        followUpSurveys: (state, getters) => {
            return state.followUpSurveys;
        },

        followUpSurveysForSurvey: (state, getters) => (surveyId) => {
            return (getters.followUpSurveys || []).filter(f => f.survey_id === surveyId);
        },
        sortedSurveys: (state) => {
            return orderBy(state.surveys, [state.sortBy], [state.sortDirection])
        },

        getSurveyBackup: (state) => (surveyId) => {
            return state.surveysBackup.find(s => s.id === surveyId) || {};
        }
    },

    actions: {
        load ({ commit, state, rootGetters }) {
            if (state.loaded || state.loading) {
                return;
            }

            state.loading = true;

            if ( ! rootGetters['apps/isAppEnabled'](Apps.Surveys)) {
                state.loaded = true;
                state.loading = false;
                return;
            }

            http.get('/app/settings/surveys')
                .then(({ data }) => {
                    commit('setSurveys', data.surveys);
                    commit('setFollowUpSurveys', data.follow_up_surveys);
                    commit('setDefaultSurveySettings', {
                        survey_settings: data.survey_settings,
                        user_can_send_messages: data.user_can_send_messages,
                        has_inactive_clients: data.has_inactive_clients,
                    })
                    state.loaded = true;
                    state.loading = false;
                }).catch(() => {
                    state.loading = false;
                });
        },

        reload({ state, dispatch }) {
            state.loaded = false;
            dispatch('load');
        },
    },
};
